import { PureComponent } from 'react';
import _ from 'lodash';
import { PAGINATION_PAGE_SIZE } from '@/configs/constants';

class ListPage extends PureComponent {
  state = {
    paramsSearch: {
      CurrentPage: 1,
      MaxResultCount: PAGINATION_PAGE_SIZE,
    },
  };

  tableChange = ({ params, type, filterType }) => {
    const { dispatch } = this.props;
    const { paramsSearch } = this.state;
    const nextParamsSearch = {
      ...paramsSearch,
      CurrentPage: _.has(params, 'CurrentPage') ? params.CurrentPage : 1,
      MaxResultCount: _.has(params, 'MaxResultCount')
        ? params.MaxResultCount
        : _.get(paramsSearch, 'MaxResultCount', PAGINATION_PAGE_SIZE),
    };
    const nextParams = this.handleRemoveParams(params, ['CurrentPage', 'MaxResultCount']);

    const payload = {
      ...nextParamsSearch,
      ...nextParams,
    };

    const promise = dispatch({
      type,
      payload,
    });
    if (filterType) {
      dispatch({
        type: filterType,
        payload,
      });
    }

    if (payload) {
      this.setState({
        paramsSearch: nextParamsSearch,
      });
    }
    return promise;
  };

  tableSearch = ({ params, type, filterType }) => {
    const nextParamsSearch = {
      ...params,
      CurrentPage: 1,
      MaxResultCount: _.has(params, 'MaxResultCount')
        ? params.MaxResultCount
        : _.get(this.state, 'paramsSearch.MaxResultCount', PAGINATION_PAGE_SIZE),
    };

    return new Promise(resolve => {
      this.setState(
        {
          paramsSearch: nextParamsSearch,
        },
        () => {
          const payload = this.handleRemoveParams(nextParamsSearch, []);
          const { dispatch } = this.props;
          const promise = dispatch({
            type,
            payload,
          });

          if (filterType) {
            dispatch({
              type: filterType,
              payload,
            });
          }

          if (promise instanceof Promise) {
            promise.then(() => {
              resolve();
            });
          } else {
            resolve();
          }
        }
      );
    });
  };

  handleRemoveParams = (params, els) => {
    const value = { ...params };
    els.forEach(key => {
      if (_.has(value, key)) {
        delete value[key];
      }
    });

    return value;
  };
}

export default ListPage;
